module.exports = __webpack_public_path__ + "img/offer-details-bg.a23d3509.jpg";